/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddNewTreatmentAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import NewTreatmentModal from './NewTreatmentModal/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconAdd from 'DesignSystem/Svgs/TysiaIconAdd/index'



/** @type {import('Simple/types.js').View} */
export default function AddNewTreatmentAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/AddNewTreatmentAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'NewTreatmentModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'NewTreatmentModal/Content'))}
 type="secondary"
 size="small"
 title="New treatment card"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconAdd
{...childProps}
  viewPath={`${viewPath}/TysiaIconAdd`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<NewTreatmentModal
  viewPath={`${viewPath}/NewTreatmentModal`}
/>
{children}
</React.Fragment>)
}